<template>
  <svg
    v-if="gSiteName === 'xoilaczxc'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_15_4710)">
      <path
        d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM13.3333 14.5L9.16667 10.3333V3.33333H10.8333V9.66667L14.5 13.3333L13.3333 14.5Z"
        fill="#7E8793"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_4710">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-else
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="4" width="8" height="2.6" fill="#9C9C9C" />
    <rect x="5" y="9.2002" width="5" height="2.6" fill="#9C9C9C" />
    <rect x="4" y="14.4004" width="6" height="2.6" fill="#9C9C9C" />
    <rect x="11" y="4" width="5" height="2.6" fill="#9C9C9C" />
    <rect x="11" y="9.2002" width="3" height="2.6" fill="#9C9C9C" />
    <rect x="11" y="14.4004" width="8" height="2.6" fill="#9C9C9C" />
  </svg>
</template>
<script lang="ts">
export default {};
</script>
